<article>
  <div class="row text-center">
    <div class="mx-auto text-left">
      <div *ngIf="!show" class="v-center">
        <app-spinner class="large"></app-spinner>
      </div>
      <div *ngIf="show" class="podcast">
        <h1>
          {{show.name}}
        </h1>
        <h2>Members-Only Podcast</h2>
        <div *ngIf="user && user.entitled">
          <div class="podcast-box">

            <p>
              Looking to get members-only podcasts in your favorite player? 
              You're in the right place!<br/>
              Tap the button corresponding to your device, or just paste the 
              URL into your favorite podcasting application and you're all set!
            </p>

            <div class="d-flex flex-row">
              <a target="_blank" class="android btn" href="{{androidPodcastUrl}}">
                  <i class="fab fa-android"></i>
              </a>
              <a target="_blank" class="ios btn" href="{{podcastUrl}}">
                  <i class="fab fa-apple"></i>
              </a>
              <a target="_blank" class="generic btn" href="{{podcastUrl}}">
                <i class="fas fa-rss" aria-hidden="true"></i>
              </a>
              <input #urlField type="text" value="{{podcastUrl}}" (click)="$event.target.select()" />
              <a target="_blank" class="copy btn" href="javascript:;" (click)="copyUrl()">
                <i class="fa fa-clipboard" aria-hidden="true"></i>
              </a>
            </div>

          </div>
        </div>
        <div *ngIf="!user || !user.entitled">
          <p>This version of the podcast is only available to TYT members.</p>
          <div style="text-align: center;">
            <a href="{{joinUrl}}" class="btn btn-primary">Join TYT</a>
          </div>
        </div>

        <br/>
        
        <div class="actions">
          <a class="btn btn-secondary" href="javascript:;" (click)="close()">Close</a>
        </div>
      </div>
    </div>
  </div>
</article>

